// import getAjax from "./ajax-functions";
function getAjax(url, success) {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.open('GET', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) {
            success(xhr.responseText);
        } else if (xhr.status !== 200) {
            console.log('Request failed.  Returned status of ' + xhr.status + ' and a ready state of ' + xhr.readyState);
        }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
    return xhr;
}

function headerSearch() {

    document.addEventListener("click", function(event) { // Detect all clicks on the document
         // If user clicks inside any of these elements, do nothing
        if (event.target.closest("#search-submenu")) return;
        if (event.target.closest("#search-bar")) return;
        document.querySelector("#search-submenu").classList.remove("is-open"); // If user clicks outside the element, hide it!
    });

    var searchBar = document.querySelector("#search-bar");
    if (searchBar) {
        searchBar.onclick = function(e) {
            var searchbox = document.querySelector("#search-submenu");
            searchbox.classList.toggle("is-open");
            document.querySelector("#header-search").focus();
            e.preventDefault();
        }
    }

    var headerSearch = document.querySelector("#header-search");
    
    if (headerSearch) {

        var SEARCH_TIMER = null;
        headerSearch.addEventListener('input',function(){
            
            var script = SITE_URL+"ajax/facelift/doKeywordSearch.php?keyword="+this.value;
            
            window.clearTimeout (SEARCH_TIMER);
            SEARCH_TIMER = window.setTimeout(
                function(){
                    getAjax(script, function(data){displayResult(data)})
            }, 1000);
        });

        function displayResult(result) {

            var searchResult = document.querySelector("#search-result");   
            searchResult.style.display="block";   
            searchResult.innerHTML = result;
        }
    }
}

export default headerSearch;